import { AppLauncher } from '@capacitor/app-launcher'
import { AnalyticsBrowser } from '@customerio/cdp-analytics-browser'
import { PushNotifications } from '@capacitor/push-notifications'
import { Capacitor } from '@capacitor/core'
import eventBus from '@/service/EventBus.js'
import { getCurrentUser } from '@/service/UserService.js'
import api from '@/service/Api.js'

const cio = AnalyticsBrowser.load({ writeKey: process.env.CIO_WRITE_KEY })
eventBus.spa.on('user-auth', userInit)

async function userInit() {
    const { userId, email, deviceToken } = await getCurrentUser()
    await cio.identify(userId, { email })
    if (!Capacitor.isNativePlatform()) return

    await cio.track('User Authenticated')
    await api.registerDevice({ deviceToken, platform: Capacitor.getPlatform() })
}

function init(router) {
    if (!Capacitor.isNativePlatform()) return

    PushNotifications.addListener('registration', async token => {
        console.log('PushNotifications registration listener')
        eventBus.spa.emit('device-token', token.value)
    }).then(console.log)

    PushNotifications.addListener('registrationError', err => {
        console.log('PushNotifications registrationError listener')
        console.error('Registration error:', err)
        console.error('Registration error:', err.error)
    }).then(console.log)

    PushNotifications.addListener('pushNotificationReceived', async notification => {
        console.log('PushNotifications pushNotificationReceived listener')
        await cio.track('Foreground Push Received', { notification })
    }).then(console.log)

    PushNotifications.addListener('pushNotificationActionPerformed', async action => {
        console.log('PushNotifications pushNotificationActionPerformed listener')
        await cio.track('Background Push Touched', { action })
        const link = action.notification.data?.link
        if (link) {
            if (link.startsWith('/')) {
                console.log(`navigating to deep link: ${link}`)
                await router.push(link)
                return
            }
            console.log(`navigating to external link: ${link}`)
            await AppLauncher.openUrl({ url: link })
            return
        }
        console.log(`no deepLink`)
    }).then(console.log)

    PushNotifications.requestPermissions().then(async ({ receive }) => {
        console.log('handlePermissionGranted: ', receive)
        if (receive === 'granted') await PushNotifications.register()
    })
}

async function addTags(tags) {
    const { userId } = await getCurrentUser()
    await cio.identify(userId, tags)
}

async function track(eventName) {
    await cio.track(eventName)
}

export default {
    init,
    addTags,
    track,
}